import {useEvent} from 'Event/EventProvider'
import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import {ActiveCampaignTag} from 'Event/activeCampaign'
import TagsAutocomplete, {
  CreateNewTagDialog,
} from 'organization/Event/Services/Apps/ActiveCampaign/Config/TagsAutocomplete'
import Button from 'lib/ui/Button'
import {useToggle} from 'lib/toggle'
import IntegrationTagField from 'organization/Event/DashboardConfig/IntegrationTagField'

export default function ActiveCampaignTagInput(props: {
  onChange: (tag: ActiveCampaignTag | null) => void
  value?: ActiveCampaignTag | null
  disabled?: boolean
  inputVariant?: 'filled' | 'standard' | 'outlined'
  label?: string
}) {
  const {value, onChange, label, inputVariant} = props

  const {event} = useEvent()
  const {flag: showCreateForm, toggle: toggleShowCreateForm} = useToggle()
  if (!event.has_active_campaign) {
    return null
  }

  const handleOnCreate = (newTag: ActiveCampaignTag) => {
    toggleShowCreateForm()
    onChange(newTag)
  }

  return (
    <>
      <IntegrationTagField>
        <TagsAutocomplete
          inputLabel={label ?? 'Active Campaign Tag'}
          value={value}
          onChange={onChange}
          inputVariant={inputVariant ?? 'outlined'}
          disabled={props.disabled ?? false}
          endAdornment={(loading, arrow) =>
            loading ? (
              <>
                <CircularProgress color="inherit" size={20} />
              </>
            ) : (
              <>
                {arrow}
                <Button
                  color="primary"
                  size="large"
                  aria-label="create tag"
                  onClick={toggleShowCreateForm}
                >
                  Create new tag
                </Button>
              </>
            )
          }
        />
      </IntegrationTagField>
      <CreateNewTagDialog
        visible={showCreateForm}
        onClose={toggleShowCreateForm}
        onCreate={handleOnCreate}
      />
    </>
  )
}
